import * as React from "react";
import { Box, Autocomplete, TextField } from "@mui/material";
import { useGetLocationsQuery } from "../services/location.service";
import { Location } from "../types/location";

const SelectLocation = ({
  onChange,
  sx,
  value,
  label = "Location",
  error,
  helperText,
}: {
  onChange: (arg?: number) => void;
  sx?: any;
  value: number;
  label?: string;
  error?: boolean;
  helperText?: React.ReactNode;
}) => {
  const {
    data: locations,
    isLoading,
    isFetching,
  } = useGetLocationsQuery({
    sortField: "name",
    sortMode: "asc",
  });

  const selected = React.useMemo(
    () => locations?.data?.find((it) => it.id == value),
    [locations, value]
  );

  return (
    <Autocomplete
      fullWidth
      options={locations?.data || []}
      value={selected || null}
      getOptionLabel={(option) => option.name}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder="Search..."
          sx={sx}
          error={error}
          helperText={helperText}
        />
      )}
      onChange={(event: any, newValue: Location | null) => {
        onChange(newValue?.id);
      }}
      loading={isLoading || isFetching}
    />
  );
};
export default SelectLocation;
